import { render } from "./B2bFilterButtonRecadvsReceived.vue?vue&type=template&id=c4b4e392&scoped=true&lang=pug"
import script from "./B2bFilterButtonRecadvsReceived.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonRecadvsReceived.vue?vue&type=script&lang=js"

import "./B2bFilterButtonRecadvsReceived.vue?vue&type=style&index=0&id=c4b4e392&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b4e392"]])

export default __exports__